import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { OutlookConnectionState } from '../../models/IOutlookPanel.interface';

/**
 * Everything the panel shows when it cannot show data: checking, not connected, or failed.
 *
 * One component rather than a block per tab, because the states are identical wherever they occur
 * and because the wording matters — this is where the read-only nature of the integration gets
 * stated plainly, and it should be stated the same way every time.
 */
@Component({
  selector: 'app-outlook-connect-state',
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './outlook-connect-state.component.html',
  styleUrls: ['./outlook-connect-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OutlookConnectStateComponent {
  @Input() state: OutlookConnectionState = 'unknown';

  /** Overrides the default copy for the error state — normally the normalised Graph message. */
  @Input() message: string | null = null;

  /** True while a connect attempt is in flight, so the button can show progress. */
  @Input() busy = false;

  @Output() connect = new EventEmitter<void>();
  @Output() retry = new EventEmitter<void>();
  @Output() signOut = new EventEmitter<void>();
}
